/**
 * The pseudo countries supported in this system.
 * These are not real countries but are used to group courts that are not associated with a specific country (Multinational Courts).
 *
 * These do not follow ISO3166. However they are prefixed with 'zz'
 * which is not a valid ISO 3166 country code to avoid any potential conflicts.
 */
export const PSEUDO_COUNTRIES = [
    {
        code: 'zz-na',
        name: 'North America - Other',
        hasStates: false,
    },
    {
        code: 'zz-eu',
        name: 'Europe - Other',
        hasStates: false,
    },
    {
        code: 'zz-oc',
        name: 'Australia / Oceania - Other',
        hasStates: false,
    },
    {
        code: 'zz-af',
        name: 'Africa - Other',
        hasStates: false,
    },
    {
        code: 'zz-zz',
        name: 'International',
        hasStates: false,
    },
];
/**
 * The countries supported in this system.
 *
 * Adding a country here makes it available as a country to associate with a Court System.
 *
 * When adding a country check its ISO 3166 code and name here https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
 */
export const SUPPORTED_COUNTRIES = [
    {
        code: 'au',
        name: 'Australia',
        stateLabelCaption: 'State / Territory',
        allStatesLabelCaption: 'All states and territories',
        hasStates: true,
    },
    { code: 'bs', name: 'Bahamas', hasStates: false },
    {
        code: 'ca',
        name: 'Canada',
        stateLabelCaption: 'Province / Territory',
        allStatesLabelCaption: 'All provinces and territories',
        hasStates: true,
    },
    {
        code: 'ky',
        name: 'Cayman Islands',
        hasStates: false,
    },
    {
        code: 'ie',
        name: 'Ireland',
        stateLabelCaption: 'Province',
        allStatesLabelCaption: 'All provinces',
        hasStates: true,
    },
    { code: 'nz', name: 'New Zealand', hasStates: false },
    { code: 'pg', name: 'Papua New Guinea', hasStates: false },
    { code: 'sc', name: 'Seychelles', hasStates: false },
    { code: 'tt', name: 'Trinidad and Tobago', hasStates: false },
    {
        code: 'gb',
        name: 'United Kingdom',
        stateLabelCaption: 'Country',
        allStatesLabelCaption: 'All countries',
        hasStates: true,
    },
    {
        code: 'us',
        name: 'United States of America',
        stateLabelCaption: 'State',
        allStatesLabelCaption: 'All states',
        hasStates: true,
    },
    {
        code: 'za',
        name: 'South Africa',
        stateLabelCaption: 'Province',
        allStatesLabelCaption: 'All provinces',
        hasStates: true,
    },
    ...PSEUDO_COUNTRIES,
];
